import React, { useState, useEffect, useContext, useRef } from 'react';

import { ThemeContext } from "../../Layout/Theme/ThemeContext";
import { useNavigate, Link, useLocation } from 'react-router-dom';
import SupplierService from "../Controller/SupplierController"
import SupplierDetailModal from "./SupplierDetail";
import Common from '../../Common/Common';
import $ from 'jquery';
import 'datatables.net-bs5';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import Swal from 'sweetalert2';
import HelpSite from "../../Common/HelpLink";
import { useTranslation } from "react-i18next";
import SageService from '../../Sage/Controller/SageController';
import ModuleService from "../../Setup/controller/ModuleController/ModuleController";
import ColumnOptionDropDown from "../../Lead/Views/LeadForms/ColumnOptionDropDown";
import Cookies from "js-cookie";
import { formatDateWithFns } from '../../Common/DateInputFormat';
import useDateFormat from '../../Common/fetchDateFormat';
import LockReleaseService from "../../Setup/controller/LockReleaseController/LockModuleController";
import CompanySetupController from "../../SuperAdmin/Controller/Client/SACompanyListController";
import QuickbookService from '../../Quickbook/QuickbookController';
import XeroService from '../../Xero/XeroController';
import UserDropdown from "../../Common/UserDropdown";
import LeadService from "../../Lead/Controller/LeadController";
import CustomerService from "../../Customer/Controller/CustomerController";
import MultiSearchDropDown from "../../Common/MultiSearchDropDown";
import InboxModal from "../../Common/InboxModal";
import JasperReportService from '../../Dashboard/Controller/JasperReportController';
import axiosInstance from '../../../config/axiosInstance';
import Draggable from 'react-draggable';
import ReportService from "../../Setup/controller/ReportController/ReportController";
import TermsConditionService from "../../Setup/controller/TermsConditionController/TermsConditionController";
import BASE_URL from "../../../config/config";
import { PDFDocument } from "pdf-lib";

function SupplierList() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const redirectCallback = () => {
    navigate('/'); // Redirect to the login page
  };
  const tableRef = useRef();
  const FormAction = "/SupplierList";

  const [modalInstance, setModalInstance] = useState(null);
  const { theme, toggleTheme } = useContext(ThemeContext);
  let accordTheme = "accordion-header-light";
  if (theme == "dark") {
    accordTheme = "accordion-header-dark";
  }
  const [supplierList, setSupplierData] = useState([]);

  const [showAssetDetailModal, setShowAssetDetailModal] = useState(false); // State to control AssetDetailModal visibility
  const [modalInstanceCustomerDetail, setModalInstanceCustomerDetail] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedParts, setSelectedParts] = useState([]);
  const [selectedId, setSelectedId] = useState("0");
  const [currentPage, setCurrentPage] = useState(1); // Current page
  const [totalPages, setTotalPages] = useState(1); // Total number of pages
  const [searchQuery, setSearchQuery] = useState('');
  const [poCount, setPOCount] = useState(0);
  const CompanyID = localStorage.getItem("CompanyID");
  const UserID = localStorage.getItem("UserID");
  const [multipleIds, setMultipleIds] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState("");
  const activeDateFormat = useDateFormat();
  const [recentSearches, setRecentSearches] = useState([]);
  const [selectedRoleName, setRoleName] = useState(localStorage.getItem("RoleName"));
  const setSortConfigInCookie = (config) => {
    Cookies.set(`SupplierSort_${CompanyID}_${UserID}`, JSON.stringify(config), { expires: 365 });
  };
  const getSortConfigFromCookie = () => {
    const sortCookie = Cookies.get(`SupplierSort_${CompanyID}_${UserID}`);
    return sortCookie ? JSON.parse(sortCookie) : { key: 'ID', direction: 'desc' };
  };
  const [sortConfig, setSortConfig] = useState(getSortConfigFromCookie());

  const setPageSizeInCookie = (pageSize) => {
    document.cookie = `pageSize=${pageSize};path=/;max-age=31536000`; // 1 year
  };
  const getPageSizeFromCookie = () => {
    const match = document.cookie.match(new RegExp('(^| )pageSize=([^;]+)'));
    return match ? parseInt(match[2], 10) : 10; // Default to 10 if no cookie is found
  };
  const [pageSize, setPageSize] = useState(getPageSizeFromCookie());

  async function fetchSearchLog() {
    try {

      const searchList = await CustomerService.GetSearchLog("5");
      setRecentSearches(searchList);
    } catch (error) {
      console.error('Error fetching Roles:', error);
    }
  }
  useEffect(() => {
    IsModuleAssigned();
    fetchSearchLog();
    fetchSuppliers(currentPage, pageSize);
  }, [currentPage, pageSize]);
  useEffect(() => {
    IsModuleAssigned();
    fetchSuppliers(currentPage, pageSize);
  }, [sortConfig]);

  const fetchSuppliers = async (page, size) => {
    try {

      setLoading(true);
      const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
      };

      const Start = Math.round((parseInt(page) * parseInt(size)) - (size - 1)).toString();
      const PageSize = size.toString();

      const data = await SupplierService.AllNewSuppliers(redirectCallback, Start.toString(), PageSize.toString(),
        searchQuery.toString(), sortConfig.key.toString(), sortConfig.direction.toString(), searchColumns.toString());
      setSupplierData(data);

      const assetCount = await SupplierService.GetSupplierCount(redirectCallback, searchQuery, searchColumns.toString());
      setPOCount(assetCount[0].TotalRecords);
      setTotalPages(Math.ceil(assetCount[0].TotalRecords / size));
    } catch (error) {
      console.error('Error fetching Teams:', error);
    }
    finally {
      setLoading(false); // Stop loading after fetching
    }
  };
  useEffect(() => {
    UserLockRelease();
    IsModuleAssigned();
    fetchSuppliers("0", pageSize);
  }, []);
  const handleCloseModal = async (isChanged) => {


    const closeModal = async () => {
      await SupplierService.UnLockSupplier(localStorage.getItem('SupplierID'));
      if (localStorage.getItem('HasRecordUpdated') == "1") {

        fetchSuppliers("0", pageSize);
      }
      setMultipleIds([]);
      setIsModalOpen(false);
    };

    if (isChanged != true) {
      closeModal();
      return;
    }

    Swal.fire({
      title: 'Are you sure?',
      text: `Are you sure you want to close this record?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, close it!'
    }).then(async (result) => {
      if (result.isConfirmed) {
        closeModal();
      }
    });
  };
  const UserLockRelease = async () => {
    try {
      const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
      };
      const CompanyID = localStorage.getItem("CompanyID");
      if (CompanyID === null || CompanyID === "null") {
        redirectCallback();
      }

      await LockReleaseService.LockReleaseByUserID(redirectCallback, "2");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "3");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "4");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "5");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "6");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "7");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "8");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "9");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "10");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "15");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "17");
      await LockReleaseService.LockReleaseByUserID(redirectCallback, "18");

    } catch (error) {
      console.error('Error fetching Teams:', error);
    }
  };
  const handleDeleteClick = async (event) => {
    event.stopPropagation(); // Prevent the row click event
    if (multipleIds.length > 0) {
      Swal.fire({
        title: 'Are you sure?',
        text: `You are about to delete ${multipleIds.length} record(s). This cannot be undone!`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            await SupplierService.DeleteSupplier(redirectCallback, multipleIds);
            setMultipleIds([]);
            fetchSuppliers("0", pageSize);
            setSelectedId("0");
            Swal.fire(
              'Deleted!',
              'Your record has been deleted.',
              'success'
            );
          } catch (error) {
            console.error('Error deleting job:', error);
            Swal.fire(
              'Error!',
              'There was a problem deleting the record.',
              'error'
            );
          }
        }
      });
    }
    else {
      Swal.fire(
        'Error!',
        'Please check at least one record to delete supplier.',
        'warning'
      );
    }
  };

  const handleCreateSupplierClick = () => {
    localStorage.setItem('SupplierID', "");
    localStorage.setItem('SupplierID', "0");
    localStorage.setItem('HasRecordUpdated', "0");
    setIsModalOpen(true);
  };
  const handleEditClick = async (SupplierID) => {
    debugger;
    const IsAlreadyLeadID = localStorage.getItem('SupplierID');
    if (IsAlreadyLeadID) {
      // await SupplierService.UnLockSupplier(IsAlreadyLeadID);
    }
    const SupplierDetail = await SupplierService.GetSupplierByID(redirectCallback, SupplierID);
    if (SupplierDetail.length > 0) {

      localStorage.setItem('SupplierID', "");
      localStorage.setItem('SupplierID', SupplierID);
      localStorage.setItem('HasRecordUpdated', "0");
      setSelectedId(SupplierID);
      setIsModalOpen(true);

    }
  };
  const truncateText = (text, maxLength = 15) => {
    return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
  };
  const handleCheckboxChange = (event, id) => {
    event.stopPropagation();
    setSelectedId((prevSelectedId) => (prevSelectedId === id ? "0" : id)); // Toggle selection
    setMultipleIds((prevSelectedIds) => {
      if (event.target.checked) {
        return [...prevSelectedIds, id];
      } else {
        return prevSelectedIds.filter((selectedId) => selectedId !== id);
      }
    });
  };
  const handleSynchronize = async (event) => {
    event.stopPropagation(); // Prevent the row click event
    const ID = selectedId;
    if (ID > 0) {
      Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Synchronize!'
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const postData = await SupplierService.SyncSupplierToFinancial(multipleIds);
            if (postData && postData.message === "Data saved successfully") {
              Swal.fire(
                'Success!',
                'The data has been processed and will be fully synced shortly.',
                'success'
              );
              await fetchSuppliers("0", pageSize);
            }

          } catch (error) {
            console.error('Error Synchronizing data:', error);
            Swal.fire(
              'Error!',
              'There was a problem in synchronizing the record.',
              'error'
            );
            await fetchSuppliers("0", pageSize);
          }
        }
      });
    }
    else {
      Swal.fire(
        'Error!',
        'Please select at least one record to synchronize.',
        'warning'
      );
    }

  };
  const redirecttoUnAuthorzied = () => {
    navigate('/Unauthorized'); // Redirect to the login page
  };
  const IsModuleAssigned = async () => {
    try {
      const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
      };
      const CompanyID = localStorage.getItem("CompanyID");
      if (CompanyID === null || CompanyID === "null") {
        redirectCallback();
      }
      const Modules = await ModuleService.GetModuleByClientID(CompanyID, "5");
      if (Modules.length === 0) {
        Swal.fire(
          'UnAuthorzied Access!',
          'Sorry, You are not authorized to access this module.',
          'warning'
        );
        redirecttoUnAuthorzied();
      }
    } catch (error) {
      console.error('Error fetching Teams:', error);
    }
  };

  const handlePageChange = (page) => {
    setSupplierData([]);
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);

    }
  };
  const handlePageSizeChange = (event) => {
    const newPageSize = parseInt(event.target.value, 10);
    setPageSize(newPageSize);
    setPageSizeInCookie(newPageSize);
    setCurrentPage(1); // Reset to the first page
  };
  const handleSearchButtonClick = async () => {
    setCurrentPage(1); // Reset to first page
    setSupplierData([]); // Clear previous data
    const query = searchQuery.toLowerCase(); // Use current searchQuery state
    let columnsToSearch = searchColumns.length > 0
      ? searchColumns.join(",")
      : "ALL";
    setSearchOptions(columnsToSearch);
    const leadData = await SupplierService.AllNewSuppliers(redirectCallback, currentPage, pageSize.toString(),
      query.toString(), sortConfig.key.toString(), sortConfig.direction.toString(), columnsToSearch.toString());
    setSupplierData(leadData);

    const leadCount = await SupplierService.GetSupplierCount(redirectCallback, searchQuery, columnsToSearch.toString());
    setPOCount(leadCount[0].TotalRecords);
    setTotalPages(Math.ceil(leadCount[0].TotalRecords / pageSize)); // Set total pages dynamically

    const searchList = await CustomerService.GetSearchLog("5");
    setRecentSearches(searchList);
  };
  const handleSort = async (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }

    const newConfig = { key, direction };
    setSortConfig(newConfig);
    setSortConfigInCookie(newConfig);
    setCurrentPage(1);

    setSortConfig({ key, direction });
    const porderData = await SupplierService.AllNewSuppliers(redirectCallback, "1", pageSize.toString(),
      searchQuery.toString(), key.toString(), direction.toString(), searchColumns.toString());

    const porderCount = await SupplierService.GetSupplierCount(redirectCallback, searchQuery, searchColumns.toString());

    setPOCount(porderCount[0].TotalRecords);
    setSupplierData(porderData);

    setTotalPages(Math.ceil(porderCount[0].TotalRecords / pageSize));
  };

  const defaultColumns = [
    "Svc_SupplierName",
    "Svc_Address1",
    "Svc_Phone",
    "Svc_Fax",
    "Svc_Website",
    "Svc_AccountRef",
    "SSynced",
    "ModifiedBy",
    "AssignTo"
  ];

  const columnOptions = [
    { value: "Svc_SupplierName", label: "Supplier" },
    { value: "Svc_Address1", label: "Address" },
    { value: "Svc_Phone", label: "Telephone" },
    { value: "Svc_Fax", label: "	Fax" },
    { value: "Svc_Website", label: "Website" },
    { value: "Svc_AccountRef", label: "	Account Ref" },
    { value: "SSynced", label: "	Synced" },
    { value: "UpdatedDate", label: "Updated Date" },
    { value: "AssignTo", label: "AssignTo" },
    { value: "ModifiedBy", label: "ModifiedBy" }
  ];
  const getStoredColumns = () => {
    const storedColumns = Cookies.get(`SupplierColumns_${CompanyID}`);
    return storedColumns ? JSON.parse(storedColumns) : columnOptions.map(option => option.value);
  };

  const [visibleColumns, setVisibleColumns] = useState(getStoredColumns());
  const handleColumnChange = (selectedOptions) => {
    setVisibleColumns(selectedOptions);

    // Save selection to cookies (valid for 1 year)
    Cookies.set(`SupplierColumns_${CompanyID}`, JSON.stringify(selectedOptions), { expires: 365 });
  };

  const [showColumnModal, setShowColumnModal] = useState(false);
  const handleAssignToUser = async (event) => {
    event.preventDefault();
    if (multipleIds.length === 0) {
      Swal.fire("Error", "Please select at least one record.", "warning");
      setSelectedUser(""); // reset dropdown
      return;
    }

    try {

      setShowColumnModal(true);
    } catch (error) {
      console.error("Error assigning user:", error);
      Swal.fire("Error", "Failed to assign records.", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleddlAssignToUser = async (userId) => {
    if (multipleIds.length === 0) {
      Swal.fire("Error", "Please select at least one record.", "warning");
      setSelectedUser(""); // reset dropdown
      return;
    }

    try {
      setLoading(true);
      await LeadService.AssignLeadToUser(multipleIds, userId, "Supplier");
      Swal.fire("Success", "Records assigned successfully.", "success");
      setMultipleIds([]); // clear selection
      setSelectedUser(""); // reset dropdown
      fetchSuppliers("0", pageSize);
    } catch (error) {
      console.error("Error assigning user:", error);
      Swal.fire("Error", "Failed to assign records.", "error");
    } finally {
      setLoading(false);
    }
  };
  const handleUnAssignToUser = async (userId) => {
    if (multipleIds.length === 0) {
      Swal.fire("Error", "Please select at least one record.", "warning");
      setSelectedUser(""); // reset dropdown
      return;
    }

    try {
      setLoading(true);
      await LeadService.UnAssignLeadToUser(multipleIds, "Supplier");
      Swal.fire("Success", "Records unassigned successfully.", "success");
      setMultipleIds([]); // clear selection
      setSelectedUser(""); // reset dropdown
      fetchSuppliers("0", pageSize);
    } catch (error) {
      console.error("Error assigning user:", error);
      Swal.fire("Error", "Failed to assign records.", "error");
    } finally {
      setLoading(false);
    }
  };

  const defaultColumnsForSearch = [
    "Svc_SupplierName",
    "Svc_Address1",
    "Svc_Phone",
    "Svc_Fax",
    "Svc_Website",
    "Svc_AccountRef",
    "SSynced",
    "AssignTo",
    "ModifiedBy"

  ];
  const [searchColumns, setSearchColumns] = useState(defaultColumnsForSearch);
  const [searchOptions, setSearchOptions] = useState(defaultColumnsForSearch);
  const columnSearchOptions = [
    { value: "Svc_SupplierName", label: "Supplier" },
    { value: "Svc_Address1", label: "Address" },
    { value: "Svc_Phone", label: "Telephone" },
    { value: "Svc_Fax", label: "	Fax" },
    { value: "Svc_Website", label: "Website" },
    { value: "Svc_AccountRef", label: "	Account Ref" },
    { value: "SSynced", label: "	Synced" },
    { value: "UpdatedDate", label: "Updated Date" },
    { value: "AssignTo", label: "AssignTo" },
    { value: "ModifiedBy", label: "ModifiedBy" }

  ];
  const handleSearchColumnChange = (selectedOptions) => {
    setSearchColumns(selectedOptions);

  };

  const handleExportExcel = async () => {

    if (multipleIds.length === 0) {
      Swal.fire(
        'Warning!',
        'Please select at least one record to export.',
        'warning'
      );
      return;
    }
    setLoading(true);
    try {

      // Filter only selected customers
      const selectedJob = supplierList.filter(job =>
        multipleIds.includes(job.PK_Supplier_ID)
      );

      if (!selectedJob || selectedJob.length === 0) {
        Swal.fire(
          'Warning!',
          'No selected data to export.',
          'warning'
        );
        return;
      }

      const headers = visibleColumns.map(col =>
        columnOptions.find(opt => opt.value === col)?.label || col
      );

      const rows = selectedJob.map(row =>
        visibleColumns.map(col => {
          let value = row[col];
          if (col === "Svc_SupplierName") {
            value = `${row.vc_SupplierName ?? ""}`;
          }
          if (col === "Svc_Address1") {
            value = `${row.vc_Address1 ?? ""}`;
          }
          if (col === "Svc_Phone") {
            value = `${row.vc_Phone ?? ""}`;
          }
          if (col === "Svc_Fax") {
            value = `${row.vc_Fax ?? ""}`;
          }
          if (col === "Svc_Website") {
            value = `${row.vc_Website ?? ""}`;
          }
          if (col === "Svc_AccountRef") {
            value = `${row.vc_AccountRef ?? ""}`;
          }
          if (col === "SSynced") {
            value = `${row.Synced ?? ""}`;
          }

          return `"${(value ?? '').toString().replace(/"/g, '""')}"`;
        }).join(',')
      );

      const csvContent = [
        headers.join(','), // CSV Header
        ...rows            // CSV Rows
      ].join('\n');

      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'Suppliers.csv');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

    } catch (error) {
      console.error('Error exporting selected customers:', error);
    } finally {
      setLoading(false);
    }
  };
  const [lastCheckedIndex, setLastCheckedIndex] = useState(null);

  // NEW: handle click (not change)
  const handleCheckboxClick = (event, id, index) => {
    event.stopPropagation();

    const isChecked = event.target.checked;

    if (event.shiftKey && lastCheckedIndex !== null) {
      const start = Math.min(lastCheckedIndex, index);
      const end = Math.max(lastCheckedIndex, index);
      const idsInRange = supplierList.slice(start, end + 1).map(l => l.PK_Supplier_ID);

      setMultipleIds(prev => {
        const s = new Set(prev);
        if (isChecked) {
          idsInRange.forEach(x => s.add(x));     // range select
        } else {
          idsInRange.forEach(x => s.delete(x));  // range unselect
        }
        return Array.from(s);
      });
    } else {
      // normal single toggle
      setMultipleIds(prev => {
        const s = new Set(prev);
        if (isChecked) s.add(id); else s.delete(id);
        return Array.from(s);
      });
    }

    // Always update the anchor index
    setLastCheckedIndex(index);
  };
  const [inboxModalOpen, setInboxModalOpen] = useState(false);
  const handleInboxEmail = async (event) => {
    if (multipleIds.length > 0) {
      event.preventDefault();
      setInboxModalOpen(true);
    }
    else {
      Swal.fire(
        'Error!',
        'Please check at least one record to process.',
        'warning'
      );
    }
  }
  const handleCloseInbox = () => {
    setInboxModalOpen(false);
  };
  const handleInboxSave = async (selectedEmails) => {
    const LeadID = multipleIds[0];
    const reponse = await LeadService.CreateCommuncationInbox(selectedEmails, LeadID, "Supplier");
    if (reponse.message == "Record saved successfully") {
      Swal.fire(
        'Success!',
        'Your record has been saved.',
        'success'
      );
    }
  };
  const getInitialWidths = () => {
    const saved = Cookies.get(`SupplierColumnWidths_${CompanyID}_${UserID}`);
    const defaults = {};

    visibleColumns.forEach(col => {
      defaults[col] = 110;
    });

    if (!saved) return defaults;

    const parsed = JSON.parse(saved);
    const applied = {};

    visibleColumns.forEach(col => {
      applied[col] = parsed[col] || 110;
    });

    return applied;
  };

  const [columnWidths, setColumnWidths] = useState(getInitialWidths);
  const startX = useRef(0);
  const startWidth = useRef(0);
  const resizingColumn = useRef(null);
  const MIN_COL_WIDTH = 60;

  /**
   * Load widths from cookie when visibleColumns changes
   */
  useEffect(() => {
    const savedWidths = Cookies.get(`SupplierColumnWidths_${CompanyID}_${UserID}`);
    if (savedWidths) {
      const parsed = JSON.parse(savedWidths);
      setColumnWidths((prev) => ({
        ...prev,
        ...parsed
      }));
    }
  }, [supplierList]);


  /**
   * Start Column Resize
   */
  const startResize = (e, key) => {
    e.stopPropagation();
    startX.current = e.clientX;
    resizingColumn.current = key;

    const th = e.target.closest("th");   // FIXED HERE
    startWidth.current = th.offsetWidth;

    document.addEventListener("mousemove", resizeColumn);
    document.addEventListener("mouseup", stopResize);
  };

  /**
   * Resize Column dynamically
   */
  const resizeColumn = (e) => {
    if (!resizingColumn.current) return;

    const delta = e.clientX - startX.current;
    const newWidth = Math.max(startWidth.current + delta, MIN_COL_WIDTH);

    setColumnWidths(prev => ({
      ...prev,
      [resizingColumn.current]: newWidth
    }));
  };
  useEffect(() => {
    setColumnWidths(getInitialWidths());
  }, [visibleColumns]);

  /**
   * Stop resizing and save to cookie
   */
  const stopResize = () => {
    document.removeEventListener("mousemove", resizeColumn);
    document.removeEventListener("mouseup", stopResize);

    const key = resizingColumn.current;
    if (key) {
      setColumnWidths(prev => {
        // Save using the most recent updated state
        Cookies.set(
          `SupplierColumnWidths_${CompanyID}_${UserID}`,
          JSON.stringify(prev),
          { expires: 365 }
        );
        return prev;
      });
    }

    resizingColumn.current = null;
  };


  /**
   * Auto-fit column width
   */
  const autoFitColumn = (key) => {
    const cells = document.querySelectorAll(`[data-col='${key}']`);
    let maxWidth = 0;

    cells.forEach(cell => {
      maxWidth = Math.max(maxWidth, cell.scrollWidth);
    });

    const newWidth = maxWidth + 20;

    const updated = { ...columnWidths, [key]: newWidth };

    setColumnWidths(updated);

    Cookies.set(
      `SupplierColumnWidths_${CompanyID}_${UserID}`,
      JSON.stringify(updated),
      { expires: 365 }
    );
  };

  const handleSyncInboxEmail = async (event) => {
    Swal.fire({
      title: 'Are you sure?',
      text: `You are about to sync inbox emails`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes!'
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await LeadService.SyncInboxEmail();
          if (response.message === "Record saved successfully") {
            Swal.fire(
              'Success!',
              'Your request for syning the inbox email is process successfully.',
              'success'
            );
          }
        } catch (error) {

          Swal.fire(
            'Error!',
            'There was a problem syncing the record.',
            'error'
          );
        }
      }
    });
  }

  const [showPdfModal, setShowPdfModal] = useState(false);
  const [imageData, setImageData] = useState(null);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [reportTitle, setReportTitle] = useState('');
  const [reportLink, setReportLink] = useState('');
  const [inputValues, setInputValues] = useState({});
  const [outputData, setOutputData] = useState([]);
  const [error, setError] = useState(null);
  const getMergedPDFBytes = async (id) => {
    try {
      const currentInputValues = {
        ClientID: localStorage.getItem("CompanyID"),
        ID: id
      };

      const redirectCallback = () => navigate('/');

      let reportData = await ReportService.GetCompanyReports(redirectCallback, "5");
      reportData = reportData.filter(x => x.IsDefault.toString() === "1");

      const reportID = reportData.length > 0 ? reportData[0].ID : 121;
      const JasperReport = await JasperReportService.GetJasperReportByID(reportID);

      const queryObjMain = {
        ...currentInputValues,
        format: 'pdf',
        ReportName: JasperReport[0].ReportName,
        ReportType: JasperReport[0].ReportType,
        name: JasperReport[0].ReportName
      };

      const responseMain = await axiosInstance.get(
        `/Dashboard/ProxyReport?${new URLSearchParams(queryObjMain)}`,
        { responseType: 'blob' }
      );

      const mainPdfBytes = await responseMain.data.arrayBuffer();

      const pdfDoc = await PDFDocument.load(mainPdfBytes);

      return pdfDoc;

    } catch (err) {
      console.error(err);
      return null;
    }
  };
  const handlePrintUser = async (event) => {
    event.stopPropagation();


    setLoading(true);
    const includeTerms = false;

    if (multipleIds.length > 0) {
      try {
        const finalMergedPdf = await PDFDocument.create();

        // ================= MERGE INVOICES =================
        for (const id of multipleIds) {

          const pdfDoc = await getMergedPDFBytes(id);

          if (!pdfDoc) continue;

          const pages = await finalMergedPdf.copyPages(
            pdfDoc,
            pdfDoc.getPageIndices()
          );

          pages.forEach(page => finalMergedPdf.addPage(page));
        }

        // ================= ADD TERMS ONLY ONCE =================


        // ================= FINAL OUTPUT =================
        const finalBytes = await finalMergedPdf.save();
        const finalBlob = new Blob([finalBytes], { type: "application/pdf" });

        const finalUrl = URL.createObjectURL(finalBlob);
        setLoading(false);
        setPdfUrl(finalUrl);
        setShowPdfModal(true);

      } catch (err) {
        console.error('Error executing report:', err);
        setError('Failed to execute the report.');
      }
    } else {
      Swal.fire(
        'Error!',
        'Please check at least one record to print job.',
        'warning'
      );
    }
  };


  const handleStart = (e, ui) => {
    e.stopPropagation();
  }
  return (

    <div>

      <Common showAddButton={'yes'} handleAddTask={handleCreateSupplierClick}
        showDeleteButton={'yes'} handleDeleteItem={handleDeleteClick}
        ModuleID={"5"} showSynchronize={'yes'} handleSynchronize={handleSynchronize}
        isDisabled={multipleIds.length > 1}
        showUnAssignUser={'yes'} handleUnAssignToUser={handleUnAssignToUser}
        showAssignUser={'yes'} handleAssignToUser={handleAssignToUser}
        showExportButton={'yes'} handleExportExcel={handleExportExcel}
        showInboxEmail={'yes'} handleInboxEmail={handleInboxEmail}
        showSyncInboxEmail={'yes'} handleSyncInboxEmail={handleSyncInboxEmail}
        showPrintUser={'yes'} handlePrintUser={handlePrintUser}
        assignmentTitle="Manage Sup..." titleBar="Manage Suppliers"
        HelpFormName="Supplier List" HelpModule="6"
        RecordID={multipleIds}
      />

      {loading && (
        <div class="loading">
          <div class="d-table">
            <div class="d-tablecell">
              <span class="loader">
                <span class="loader-inner"></span>
              </span>
            </div>
          </div>
        </div>
      )}
      <div className="main-content-header">
        <div className="row">
          <div className="col-xl-2">
            <h1>{t('suppliersHeader')}</h1>
          </div>

          <div className="col-xl-10 d-flex justify-content-end">
            <div className="col-sm-2 d-flex">

            </div>
            <ColumnOptionDropDown
              options={columnOptions}
              selectedOptions={visibleColumns}
              onChange={handleColumnChange}
            />

          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-xl-12">
          <div className="card mb-30">
            <div className="card-body">

              <div className="table-responsive" style={{ overflow: "visible" }}>
                <div className="row mb-3">
                  <div className="col-sm-1">
                    <select id="pageSize" className="form-control" value={pageSize} onChange={handlePageSizeChange}>
                      <option value={10}>10</option>
                      <option value={25}>25</option>
                      <option value={50}>50</option>
                      <option value={100}>100</option>
                      <option value={500}>500</option>
                      <option value={1000}>1000</option>
                    </select>
                  </div>
                  <label style={{ paddingLeft: "0px" }} className="col-sm-2" htmlFor="pageSize">entries per page: </label>
                  <div className="col-sm-6"></div>
                  <div className="col-sm-1 d-flex align-items-center justify-content-end">
                    <span className="me-2">Search</span>

                    <MultiSearchDropDown
                      options={columnSearchOptions}
                      selectedOptions={searchColumns}
                      onChange={handleSearchColumnChange}
                    />
                  </div>
                  <div className="col-sm-2 d-flex justify-content-end">
                    <input
                      list="recent-searches"
                      type="text"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      className="form-control me-2"
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          handleSearchButtonClick();
                        }
                      }}
                    />
                    <datalist id="recent-searches">
                      {recentSearches.map((item, idx) => (
                        <option key={idx} value={item.SearchQuery} />
                      ))}
                    </datalist>
                    <button onClick={() => handleSearchButtonClick()} style={{ background: "none", border: "none" }}>
                      <img src="assets/img/resources/search.png" class="top-icon" alt="Add icon" />
                    </button>
                  </div>
                </div>
                <div style={{ maxHeight: "80vh", overflow: "auto" }}>
                  <table
                    style={{
                      tableLayout: "fixed",
                      width: "max-content",
                      minWidth: "100%"
                    }}
                    className="table m-0 table-hover"
                    ref={tableRef}
                  >
                    <thead classname="table-light" style={{ position: "sticky", top: 0, zindex: 2 }}>
                      <tr>
                        <th
                          className="checkbox-header"
                          style={{
                            width: "40px",
                            minWidth: "40px",
                            maxWidth: "40px",
                            position: "sticky",
                            left: 0,
                            zIndex: 5,

                          }}
                        ></th>
                        {visibleColumns.includes("Svc_SupplierName") &&
                          <th onClick={() => handleSort('vc_SupplierName')}

                            style={{
                              width: `${columnWidths?.vc_SupplierName}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">Supplier<i
                              className={`ms-1 icofont ${sortConfig.key === 'vc_SupplierName'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "vc_SupplierName");
                              }}
                              onDoubleClick={() => autoFitColumn("vc_SupplierName")}
                            /></th>
                        }
                        {visibleColumns.includes("Svc_Address1") &&
                          <th onClick={() => handleSort('vc_Address1')}

                            style={{
                              width: `${columnWidths?.vc_Address1}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">Address<i
                              className={`ms-1 icofont ${sortConfig.key === 'vc_Address1'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "vc_Address1");
                              }}
                              onDoubleClick={() => autoFitColumn("vc_Address1")}
                            /></th>
                        }
                        {visibleColumns.includes("Svc_Phone") &&
                          <th onClick={() => handleSort('vc_Phone')}

                            style={{
                              width: `${columnWidths?.vc_Phone}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">Telephone<i
                              className={`ms-1 icofont ${sortConfig.key === 'vc_Phone'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "vc_Phone");
                              }}
                              onDoubleClick={() => autoFitColumn("vc_Phone")}
                            /></th>
                        }
                        {visibleColumns.includes("Svc_Fax") &&
                          <th onClick={() => handleSort('vc_Fax')}

                            style={{
                              width: `${columnWidths?.vc_Fax}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">Fax<i
                              className={`ms-1 icofont ${sortConfig.key === 'vc_Fax'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "vc_Fax");
                              }}
                              onDoubleClick={() => autoFitColumn("vc_Fax")}
                            /></th>
                        }
                        {visibleColumns.includes("Svc_Website") &&
                          <th onClick={() => handleSort('vc_Website')}

                            style={{
                              width: `${columnWidths?.vc_Website}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">Website<i
                              className={`ms-1 icofont ${sortConfig.key === 'vc_Website'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "vc_Website");
                              }}
                              onDoubleClick={() => autoFitColumn("vc_Website")}
                            /></th>
                        }
                        {visibleColumns.includes("Svc_AccountRef") &&
                          <th onClick={() => handleSort('vc_AccountRef')}

                            style={{
                              width: `${columnWidths?.vc_AccountRef}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">Account Ref<i
                              className={`ms-1 icofont ${sortConfig.key === 'vc_AccountRef'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "vc_AccountRef");
                              }}
                              onDoubleClick={() => autoFitColumn("vc_AccountRef")}
                            /></th>
                        }
                        {visibleColumns.includes("UpdatedDate") &&
                          <th onClick={() => handleSort('UpdatedDate')}

                            style={{
                              width: `${columnWidths?.UpdatedDate}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">Last Action
                            <i
                              className={`ms-1 icofont ${sortConfig.key === 'UpdatedDate'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "UpdatedDate");
                              }}
                              onDoubleClick={() => autoFitColumn("UpdatedDate")}
                            />
                          </th>
                        }
                        {visibleColumns.includes("AssignTo") &&
                          <th onClick={() => handleSort('AssignTo')}

                            style={{
                              width: `${columnWidths?.AssignTo}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">Assign To
                            <i
                              className={`ms-1 icofont ${sortConfig.key === 'AssignTo'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i><div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "AssignTo");
                              }}
                              onDoubleClick={() => autoFitColumn("AssignTo")}
                            />
                          </th>
                        }
                        {visibleColumns.includes("ModifiedBy") &&
                          <th onClick={() => handleSort('ModifiedBy')}
                            style={{
                              width: `${columnWidths?.ModifiedBy}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">Modified By
                            <i
                              className={`ms-1 icofont ${sortConfig.key === 'ModifiedBy'
                                ? sortConfig.direction === 'asc'
                                  ? 'icofont-caret-up'
                                  : 'icofont-caret-down'
                                : 'icofont-sorting'
                                }`}
                            ></i>
                            <div
                              className="resize-handle"
                              onMouseDown={(e) => {
                                e.stopPropagation();   // STOP the click event from bubbling
                                startResize(e, "ModifiedBy");
                              }}
                              onDoubleClick={() => autoFitColumn("ModifiedBy")}
                            />
                          </th>
                        }
                        {visibleColumns.includes("SSynced") &&
                          <th

                            style={{
                              width: `${columnWidths?.SSynced}px`,
                              minWidth: `${MIN_COL_WIDTH}px`
                            }}
                            className="resizable ellipsis">Synced</th>
                        }

                      </tr>
                    </thead>
                    <tbody>
                      {supplierList.map((supplier, index) => (

                        <tr key={supplier.PK_Supplier_ID}
                          onClick={() => handleEditClick(supplier.PK_Supplier_ID)}
                          style={{
                            backgroundColor: selectedId.toString() === supplier.PK_Supplier_ID.toString() ? 'rgb(197, 218, 237)' : '', // Highlight background
                            cursor: 'pointer',
                          }}>
                          <td
                            className="checkbox-cell"
                            onClick={(e) => e.stopPropagation()}
                            style={{
                              width: "40px",
                              minWidth: "40px",
                              maxWidth: "40px",
                              position: "sticky",
                              left: 0,
                              zIndex: 3,
                              backgroundColor:
                                selectedId.toString() === supplier.PK_Supplier_ID.toString()
                                  ? 'rgb(197, 218, 237)'
                                  : '#fff'
                            }}
                          >
                            <div
                              className="checkbox-hover-area"
                              onClick={(event) => handleCheckboxClick(event, supplier.PK_Supplier_ID, index)}
                            >
                              <input
                                type="checkbox"
                                checked={multipleIds.includes(supplier.PK_Supplier_ID)}
                                readOnly
                              />
                            </div>
                          </td>
                          {visibleColumns.includes("Svc_SupplierName") && <td style={{
                            width: columnWidths.vc_SupplierName,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis" title={supplier.vc_SupplierName}>{supplier.vc_SupplierName}</td>}

                          {visibleColumns.includes("Svc_Address1") && <td style={{
                            width: columnWidths.vc_Address1,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis" title={supplier.vc_Address1}>{supplier.vc_Address1}</td>}
                          {visibleColumns.includes("Svc_Phone") && <td style={{
                            width: columnWidths.vc_Phone,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis">
                            <a href={`tel:${supplier.vc_Phone}`} onClick={(e) => e.stopPropagation()}>
                              {supplier.vc_Phone}
                            </a>
                          </td>}
                          {visibleColumns.includes("Svc_Fax") && <td style={{
                            width: columnWidths.vc_Fax,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis">{supplier.vc_Fax}</td>}
                          {visibleColumns.includes("Svc_Website") && <td style={{
                            width: columnWidths.vc_Website,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis">{supplier.vc_Website}</td>}
                          {visibleColumns.includes("Svc_AccountRef") && <td style={{
                            width: columnWidths.vc_AccountRef,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis">{supplier.vc_AccountRef}</td>}
                          {visibleColumns.includes("UpdatedDate") && <td style={{
                            width: columnWidths.UpdatedDate,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis">{formatDateWithFns(supplier.UpdatedDate, activeDateFormat)}  </td>}
                          {visibleColumns.includes("AssignTo") && <td style={{
                            width: columnWidths.AssignTo,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis">
                            {supplier.AssignTo ? (
                              <div
                                title={supplier.AssignTo}
                                style={{
                                  display: "inline-flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  width: "25px",
                                  height: "25px",
                                  borderRadius: "50%",
                                  backgroundColor: "#007bff",
                                  color: "white",
                                  fontWeight: "bold",
                                  fontSize: "14px",
                                }}
                              >
                                {supplier.AssignTo.split(" ")
                                  .map(word => word.charAt(0).toUpperCase())
                                  .join("")}
                              </div>
                            ) : (
                              ""
                            )}
                          </td>}
                          {visibleColumns.includes("ModifiedBy") && <td style={{
                            width: columnWidths.ModifiedBy,
                            minWidth: MIN_COL_WIDTH,
                          }} className="no-wrap ellipsis">
                            {supplier.ModifiedBy ? (
                              <div
                                title={supplier.ModifiedBy}
                                style={{
                                  display: "inline-flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  width: "25px",
                                  height: "25px",
                                  borderRadius: "50%",
                                  backgroundColor: "#368938",
                                  color: "white",
                                  fontWeight: "bold",
                                  fontSize: "14px",
                                }}
                              >
                                {supplier.ModifiedBy.split(" ")
                                  .map(word => word.charAt(0).toUpperCase())
                                  .join("")}
                              </div>
                            ) : (
                              ""
                            )}
                          </td>}
                          {visibleColumns.includes("SSynced") &&
                            <td style={{
                              width: columnWidths.SSynced,
                              minWidth: MIN_COL_WIDTH,
                            }} className="no-wrap ellipsis">
                              {supplier.IsSynced === 1 && (
                                <img src='assets/img/resources/tick.png' style={{ width: "20px" }}></img>
                              )}
                              {supplier.IsSynced === 2 && (
                                <img src='assets/img/resources/sync.JPG' style={{ width: "50px" }}></img>
                              )}
                            </td>
                          }
                        </tr>
                      ))}
                    </tbody>
                    <tfoot style={{ position: "sticky", bottom: 0, zIndex: 2, backgroundColor: "white" }}>
                      <tr>
                        <td colSpan={visibleColumns.length + 1}>
                          <div className="pagination-controls" style={{ marginTop: "10px", marginBottom: "10px" }}>
                            Showing {1 + (currentPage * pageSize) - pageSize} to {currentPage * (Math.min(poCount, pageSize))} of {poCount} entries

                            {/* Last Page Button */}
                            <button
                              style={{ float: "right", marginLeft: "5px" }}
                              className='btn btn-info'
                              onClick={() => handlePageChange(totalPages)} // Navigate to last page
                              disabled={currentPage === totalPages}
                            >
                              <img src="assets/img/resources/last.png" alt="Add icon" style={{ height: "10px" }} />  Last
                            </button>

                            {/* Next Page Button */}
                            <button
                              style={{ float: "right", marginLeft: "5px" }}
                              className='btn btn-info'
                              onClick={() => handlePageChange(currentPage + 1)}
                              disabled={currentPage === totalPages}
                            >
                              <img src="assets/img/resources/next-icon.png" alt="Add icon" style={{ height: "10px" }} /> Next
                            </button>

                            <span style={{ marginLeft: "10px", marginRight: "10px", float: "right" }}>
                              Page {currentPage} of {totalPages}
                            </span>

                            {/* Previous Page Button */}
                            <button
                              style={{ float: "right", marginRight: "5px", marginLeft: "5px" }}
                              className='btn btn-info'
                              onClick={() => handlePageChange(currentPage - 1)}
                              disabled={currentPage === 1}
                            >
                              <img src="assets/img/resources/pevious-icon.png" alt="Add icon" style={{ height: "10px" }} /> Prev
                            </button>

                            {/* First Page Button */}
                            <button
                              style={{ float: "right" }}
                              className='btn btn-info'
                              onClick={() => handlePageChange(1)} // Navigate to first page
                              disabled={currentPage === 1}
                            >
                              <img src="assets/img/resources/first.png" alt="Add icon" style={{ height: "10px" }} /> First
                            </button>
                          </div>
                        </td>
                      </tr>
                    </tfoot>
                  </table>


                </div>
                {isModalOpen && (
                  <SupplierDetailModal SupplierID={localStorage.getItem('SupplierID')} onClose={handleCloseModal} onSuccess={fetchSuppliers} />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {showColumnModal && (
        <div
          className="modal show fade"
          style={{ display: "block", background: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Assign Engineer</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowColumnModal(false)}
                ></button>
              </div>

              <div className="modal-body">
                <div className="row mb-3" style={{ "marginLeft": "0px", "marginRight": "0px", "marginTop": "10px" }}>

                  <div className="col-sm-12">
                    {selectedRoleName === "Administrator" && (
                      <UserDropdown
                        value={selectedUser}
                        onChange={(val) => {
                          setSelectedUser(val);
                          if (val) handleddlAssignToUser(val);
                        }}
                        showLabel={false}
                      />
                    )}
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => setShowColumnModal(false)}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}



      {inboxModalOpen && (
        <InboxModal onSave={handleInboxSave} onClose={handleCloseInbox} />
      )}
      {showPdfModal && pdfUrl && (
        <div className="modal fade show d-block" tabIndex="-1">
          <div className="modal-dialog modal-lg">
            <Draggable handle=".modal-content" onStart={handleStart}>
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">PDF Report</h5>
                  <button type="button" className="close" onClick={() => setShowPdfModal(false)}>
                    <span>&times;</span>
                  </button>
                </div>
                <div className="modal-body">
                  <embed src={pdfUrl} type="application/pdf" width="100%" height="600px" />
                </div>
              </div>
            </Draggable>
          </div>
        </div>
      )}
    </div>


  );
}
export default SupplierList;